var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowers06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#faf4ed;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-1",
    d: "M280.93,320.86l-4.09-6.37c-56.44-88-36.9-209.42,43.64-271.13l4.09,6.37C381,137.8,361.51,259.14,280.93,320.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-1",
    d: "M290.27,313.72C209.7,375.44,98.65,354.08,42.23,266l-4.09-6.37c80.54-61.71,191.58-40.38,248,47.67Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowers06);
export default __webpack_public_path__ + "static/media/flowers-06.2c556679a53a65770d8fa2bc33b0c08f.svg";
export { ForwardRef as ReactComponent };